// ABOUTME: The shared sky-and-sea backdrop of the deck steps: the sky it is asked for above the horizon, the v28 sea (DeckSea) below.
// ABOUTME: The sea is the same on every step; only the sky differs (cream, the 2A Feeling sky, or none for a screen that draws its own).

import { Box } from '@mui/material';
import { CROSSING_FEELING_SKY_BOTTOM, CROSSING_FEELING_SKY_TOP, CROSSING_SKY_CREAM } from '../../../theme/crossingTokens';
import { buildInFade, buildInRise } from './deckBuildIn';
import FeelingStormSky from '../screens/feelings/FeelingStormSky';
import DeckSea from './DeckSea';
import { useHorizon } from './useHorizon';
import { useCrossingReducedMotion } from './useReducedMotion';

interface OceanSceneProps {
  // 'cream' is the plain sky; 'feeling' is the cream-grey gradient 2A reads feelings under; 'none' leaves the sky to a layer
  // the screen draws itself (5C's forgiven sky).
  sky?: 'cream' | 'feeling' | 'none';
  buildIn?: boolean; // 2A arriving from Ready for compass: the sky fades in and the sea rises into place
}

export default function OceanScene({ sky = 'cream', buildIn = false }: OceanSceneProps) {
  const { line } = useHorizon();
  const reducedMotion = useCrossingReducedMotion();
  const animate = buildIn && !reducedMotion;
  // position:fixed covering the whole viewport (not position:absolute sized by an ancestor's
  // flex-computed height) -- bryan, manual-test: the sky rendered the wrong color and the water
  // stopped short of the bottom of the screen, both symptoms of this box not actually getting the
  // real remaining viewport height through the runner frame's flex
  // chain. Anchoring directly to the viewport (the same technique the runner plate uses;
  // runner plate) guarantees full top-to-bottom coverage regardless of that chain. zIndex sits
  // behind the header (which has its own opaque background) and behind the plate (zIndex 10).
  return (
    <Box
      aria-hidden
      sx={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        zIndex: -1,
        backgroundColor: sky === 'none' ? undefined : CROSSING_SKY_CREAM,
      }}
    >
      {sky === 'feeling' && (
        <Box
          data-testid="ocean-scene-feeling-sky"
          sx={{
            position: 'absolute', left: 0, right: 0, top: 0, height: line, background: `linear-gradient(${CROSSING_FEELING_SKY_TOP}, ${CROSSING_FEELING_SKY_BOTTOM})`,
            ...(animate ? buildInFade : {}),
          }}
        >
          <FeelingStormSky />
        </Box>
      )}
      <Box data-testid="ocean-scene-rise" sx={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, ...(animate ? buildInRise : {}) }}>
        <DeckSea />
      </Box>
    </Box>
  );
}
